import React from 'react';
import Style from '../../assets/style.scss';
import { BCCard, BCDataGrid, BCDivider, findMessage } from '@bimser/components';

interface IUserAction {
	id: number;
	department: string;
	firstNameLastName: string;
	isOnline: boolean;
	lastLoginDate: string;
	lastProcess: string;
}
const allowedPageSizes = [10, 20, 30, 50];

const LicenceUsers = props => {
	const bcDataGridRef = React.useRef<BCDataGrid.Entities.BCDataGridRef>();
	const onlineCellRender = e => {
		if (e.row.data?.isOnline) return <span className={Style.circleGreen} />;
		return <span className={Style.circleRed} />;
	};

	const columns = React.useMemo(
		(): BCDataGrid.Entities.IColumnProps[] => [
			{
				name: 'id',
				dataField: 'id',
				caption: 'id',
				dataType: 'number',
				visible: false
			},
			{
				name: 'firstNameLastName',
				dataField: 'firstNameLastName',
				dataType: 'string',
				caption: findMessage.get('100728'),
				selectedFilterOperation: 'contains'
			},
			{
				name: 'department',
				dataField: 'department',
				dataType: 'string',
				caption: findMessage.get('100472'),
				selectedFilterOperation: 'contains'
			},
			{
				name: 'isOnline',
				dataField: 'isOnline',
				dataType: 'boolean',
				width: 100,
				caption: findMessage.get('100392'),
				selectedFilterOperation: '=',
				cellRender: onlineCellRender
			},
			{
				name: 'lastLoginDate',
				dataField: 'lastLoginDate',
				dataType: 'datetime',
				caption: findMessage.get('103317'),
				selectedFilterOperation: '=',
				width: 200
			},
			{
				name: 'lastProcess',
				dataField: 'lastProcess',
				dataType: 'string',
				caption: findMessage.get('103326'),
				selectedFilterOperation: 'contains'
			}
		],
		[]
	);

	return (
		<BCCard
			bordered={false}
			className={Style.licenceUsersContainer}
			seleniumId={'licenceUsersCard'}
			bodyStyle={{ height: '100%' }}
		>
			<div className={Style.licenceUserHeader}>
				<span className={[Style.headerTitle, Style.fontWeightBoldTitle].join(' ')}>
					{findMessage.get('103314')}
				</span>
			</div>
			<BCDivider className={Style.licenceUserDivider} />
			<div className={Style.licenceUserGridContainer}>
				<BCDataGrid.Components.DataGrid
					name={BCDataGrid.Entities.DataGrids.LicenceUsers}
					ref={bcDataGridRef}
					dataSource={props.actions}
					keyExpr="id"
					remoteOperations
					cacheEnabled
					height="100%"
					cellHintEnabled
					showColumnLines={false}
					showRowLines
					columnAutoWidth
					className={Style.licenceUserGrid}
				>
					<BCDataGrid.Components.Paging
						enabled
						defaultPageSize={10}
						defaultPageIndex={0}
					/>
					<BCDataGrid.Components.Pager
						allowedPageSizes={allowedPageSizes}
						showPageSizeSelector
						showNavigationButtons
						visible
						showInfo
					/>
					<BCDataGrid.Components.FilterRow
						key="filterRow"
						visible
					/>
					<BCDataGrid.Components.Sorting mode="multiple" />
					<BCDataGrid.Components.SearchPanel visible />
					{columns.map(column => (
						<BCDataGrid.Components.Column
							key={column.name}
							{...column}
						/>
					))}

					<BCDataGrid.Components.Item name="searchPanel" />
				</BCDataGrid.Components.DataGrid>
			</div>
		</BCCard>
	);
};

export { LicenceUsers as default, IUserAction };
